import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=12954328&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=12954328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12954328",
  null
  
)

export default component.exports